import { Collection } from 'modules/core/lib/mobx-rest'

import type Employee from 'modules/employees/store/models/Employee'
import type Allowance from 'modules/timeoff/store/models/Allowance'
import TimeoffPolicy from 'modules/timeoff/store/models/TimeoffPolicy/Policy'

export interface AllowanceMapItem {
  originalAllowanceId: number
  newAllowanceId: number
  _destroy: boolean
}
export type BulkAssignEmployeesDto = {
  employeeIds: number[]
  mappings: AllowanceMapItem[]
  policyId: number
}

class TimeoffPolicies extends Collection<TimeoffPolicy> {
  model() {
    return TimeoffPolicy
  }

  bulkAssignEmployees(dataStructure: BulkAssignEmployeesDto) {
    const { employeeIds, mappings, policyId } = dataStructure
    const normalizedMappings = mappings.map((obj) => {
      return {
        original_allowance_id: obj.originalAllowanceId,
        new_allowance_id: obj.newAllowanceId,
        _destroy: obj._destroy,
      }
    })

    return this.rpc('bulk_assign_employees', {
      employee_ids: employeeIds,
      mappings: normalizedMappings,
      policy_id: policyId,
    })
  }
}

export { TimeoffPolicies }

const singleton: TimeoffPolicies = new TimeoffPolicies()

export const allowancePolicy = (allowance: Allowance) => {
  const timeoffPolicyId = allowance.attributes.timeoff_policy_id

  return singleton.get(timeoffPolicyId)
}

export const employeePolicy = (employee: Employee) => {
  const policyId = employee.attributes.timeoff_policy_id
  const policy = singleton.get(policyId)

  if (!policy) {
    throw Error(`Error getting policies with id = ${policyId}`)
  }

  return policy
}

export default singleton
